import 'dayjs/locale/en';
import 'dayjs/locale/fr';
import dayjs from 'dayjs';
import { I18n } from 'i18n-js';
import type { TranslateOptions } from 'i18n-js';

import en from './locales/en.json';
import fr from './locales/fr.json';
import { Leaves, LocalizedDictionary } from './types';
import { storage } from '../storage/storage';

const supportedLocales = ['fr', 'en'] as const;
type SupportedLocales = (typeof supportedLocales)[number];

const LOCALE_STORAGE_KEY = 'locale';
const i18n = new I18n({ en, fr });

const initialLocale =
  supportedLocales.find(l => (storage.getItem(LOCALE_STORAGE_KEY) || navigator.language).startsWith(l)) || 'fr';

i18n.defaultLocale = 'fr';
i18n.enableFallback = true;
i18n.locale = initialLocale;

dayjs.locale(initialLocale);

export const t = (key: Leaves<LocalizedDictionary>, options?: TranslateOptions) => i18n.t(key, options);
export const tPlural = (key: string, options?: TranslateOptions) => i18n.t(key, options);
export const locale = i18n.locale as SupportedLocales;
export const setLocale = (newLocale: SupportedLocales) => {
  storage.setItem(LOCALE_STORAGE_KEY, newLocale);
  window.location.reload();
};
